export enum SkuEngraving {
    EVENT_NAME = 'engraving',
    EVENT_CATEGORY = 'engraving',
    EVENT_ACTION = 'overlay',
    EVENT_LABEL = '1st page loaded',
    EVENT_NONINTERACTION = 'FALSE'
}
